import { Component, OnInit, ChangeDetectionStrategy, Inject, ChangeDetectorRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Report, ReportView } from 'src/app/features/reports/models';

@Component({
  selector: 'app-link-user-to-report-dialog',
  templateUrl: './link-user-to-report-dialog.component.html',
  styleUrls: ['./link-user-to-report-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkUserToReportDialogComponent implements OnInit {
  reports: Report[] = [];
  reportsByUser: ReportView[] = [];
  constructor(
      public builder: FormBuilder,
      public dialogRef: MatDialogRef<LinkUserToReportDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public cdr: ChangeDetectorRef
  ) {
    this.reports = this.data.reports;
    this.reportsByUser = this.data.reportsByUser;
    this.compareReportsAndReportsByUser();
  }
  compareReportsAndReportsByUser() {
      if (this.reportsByUser) {
        this.reports.forEach((e1) => this.reportsByUser.forEach((e2) => {
          if (e1.id === e2.id) {
            this.reports = this.reports.filter(x => x.id !== e1.id);
            const report: Report = {
              id: e1.id,
              name: e1.name,
              selected: true,
            };
            this.reports.push(report);
          }
        }));
      }
  }
  onCancelClick(): void {
      this.dialogRef.close();
  }
  onReportChecked(checked: boolean, index: number, report: any) {
    const updateReport: Report = {
      id: report.id,
      name: report.name,
      selected: checked
    };
    this.reports = this.reports.filter(x => x.id !== report.id);
    this.reports.splice(index, 0, updateReport);
    this.cdr.detectChanges();
  }

  onLinkReportClick(): void {
    const report = this.reports.filter(x => x.selected);
    this.dialogRef.close(report);
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
  }
}
